import { createAction, createSetterActions } from "@/redux/helpers/action";

import { MODULE } from "./constants";

// Simple setter action (dispatch with value): setIsOpen(true) / setIsOpen(false)
export const [setIsOpen] = createSetterActions(MODULE, ["isOpen"]);

// Custom action to restore initial state
export const reset = createAction(`${MODULE}/RESET`);
